<p-toast></p-toast>
<p-confirmDialog [style]="{ width: '480px' }"></p-confirmDialog>

<div *ngIf="showAdvancedView" class="advanced-registrations">
  <!-- ===================== INDICADORES ===================== -->
  <div class="advanced-registrations__kpis">
    <div class="kpi-card kpi-card--total">
      <div class="kpi-card__icon"><i class="pi pi-users"></i></div>
      <div class="kpi-card__content">
        <span class="kpi-card__value">{{ totals.registrations }}</span>
        <span class="kpi-card__label">Inscripciones totales</span>
      </div>
    </div>

    <div
      class="kpi-card kpi-card--success kpi-card--clickable"
      (click)="filterByStatus(statusOptions[0].value)"
      pTooltip="Filtrar solo deportistas inscritos"
      tooltipPosition="bottom"
    >
      <div class="kpi-card__icon"><i class="pi pi-check-circle"></i></div>
      <div class="kpi-card__content">
        <span class="kpi-card__value">{{ totals.registered }}</span>
        <span class="kpi-card__label">Inscritos</span>
      </div>
    </div>

    <div
      class="kpi-card kpi-card--warning kpi-card--clickable"
      (click)="filterByStatus(statusOptions[1].value)"
      pTooltip="Filtrar solo pre-inscritos (pago pendiente)"
      tooltipPosition="bottom"
    >
      <div class="kpi-card__icon"><i class="pi pi-clock"></i></div>
      <div class="kpi-card__content">
        <span class="kpi-card__value">{{ totals.preRegistered }}</span>
        <span class="kpi-card__label">Pre-Inscritos</span>
      </div>
    </div>

    <div
      class="kpi-card kpi-card--danger kpi-card--clickable"
      (click)="filterByStatus(statusOptions[2].value)"
      pTooltip="Filtrar solo registros no inscritos"
      tooltipPosition="bottom"
    >
      <div class="kpi-card__icon"><i class="pi pi-times-circle"></i></div>
      <div class="kpi-card__content">
        <span class="kpi-card__value">{{ totals.notRegistered }}</span>
        <span class="kpi-card__label">No Inscritos</span>
      </div>
    </div>

    <div class="kpi-card kpi-card--info">
      <div class="kpi-card__icon"><i class="pi pi-building"></i></div>
      <div class="kpi-card__content">
        <span class="kpi-card__value">{{ totals.clubs }}</span>
        <span class="kpi-card__label">
          Clubes / Escuelas
          <small>{{ totals.clubsWithRegistration }} con inscripción de club</small>
        </span>
      </div>
    </div>

    <div class="kpi-card kpi-card--amount">
      <div class="kpi-card__icon"><i class="pi pi-dollar"></i></div>
      <div class="kpi-card__content">
        <span class="kpi-card__value"
          >${{ totals.confirmedAmount | number }}</span
        >
        <span class="kpi-card__label">
          Valor confirmado
          <small>${{ totals.pendingAmount | number }} pendiente</small>
        </span>
      </div>
    </div>
  </div>

  <!-- ===================== ALERTA DE INCONSISTENCIAS ===================== -->
  <div class="advanced-registrations__orphan-alert" *ngIf="orphanRows > 0">
    <i class="pi pi-exclamation-triangle"></i>
    <span>
      <strong>{{ orphanRows }}</strong> inscripción(es) no tienen deportista
      asociado: el club lo eliminó de su escuela después de inscribirlo. La
      inscripción y su pago siguen siendo válidos, pero los datos del deportista
      ya no están disponibles.
    </span>
  </div>

  <!-- ===================== FILTROS ===================== -->
  <div class="advanced-registrations__filters">
    <div class="filters__row">
      <span class="p-input-icon-left filters__search">
        <i class="pi pi-search"></i>
        <input
          pInputText
          type="text"
          [(ngModel)]="searchTerm"
          (input)="applyFilters()"
          placeholder="Buscar club, identificación, nombre, categoría..."
        />
      </span>

      <p-multiSelect
        [options]="statusOptions"
        [(ngModel)]="statusFilter"
        (onChange)="applyFilters()"
        optionLabel="label"
        optionValue="value"
        placeholder="Estado de inscripción"
        display="chip"
        styleClass="filters__control"
      ></p-multiSelect>

      <p-multiSelect
        [options]="clubOptions"
        [(ngModel)]="clubFilter"
        (onChange)="applyFilters()"
        optionLabel="label"
        optionValue="value"
        placeholder="Clubes / Escuelas"
        [filter]="true"
        styleClass="filters__control"
      ></p-multiSelect>

      <p-multiSelect
        [options]="temporalOptions"
        [(ngModel)]="temporalFilter"
        (onChange)="applyFilters()"
        optionLabel="label"
        optionValue="value"
        placeholder="Tipo de inscripción"
        styleClass="filters__control"
      ></p-multiSelect>

      <p-multiSelect
        [options]="paymentStatusOptions"
        [(ngModel)]="paymentStatusFilter"
        (onChange)="applyFilters()"
        optionLabel="label"
        optionValue="value"
        placeholder="Estado de pago"
        styleClass="filters__control"
      ></p-multiSelect>
    </div>

    <div class="filters__row filters__row--actions">
      <div class="filters__toggles">
        <p-checkbox
          [(ngModel)]="onlyWithPendings"
          (onChange)="applyFilters()"
          [binary]="true"
          inputId="onlyWithPendings"
        ></p-checkbox>
        <label for="onlyWithPendings">Solo clubes con pre-inscritos</label>

        <ng-container *ngIf="isSuperAdmin">
          <p-checkbox
            [(ngModel)]="includeDeleted"
            (onChange)="onIncludeDeletedChange()"
            [binary]="true"
            inputId="includeDeleted"
          ></p-checkbox>
          <label for="includeDeleted">Ver eliminadas</label>
        </ng-container>

        <p-selectButton
          [options]="viewModeOptions"
          [(ngModel)]="viewMode"
          optionLabel="label"
          optionValue="value"
          styleClass="filters__view-mode"
        ></p-selectButton>
      </div>

      <div class="filters__buttons">
        <p-button
          *ngIf="hasActiveFilters"
          icon="pi pi-filter-slash"
          label="Limpiar filtros"
          severity="secondary"
          [outlined]="true"
          size="small"
          (onClick)="clearFilters()"
        ></p-button>
        <p-button
          *ngIf="viewMode === 'CLUBS'"
          icon="pi pi-angle-double-down"
          label="Expandir"
          severity="secondary"
          [outlined]="true"
          size="small"
          (onClick)="expandAll()"
        ></p-button>
        <p-button
          *ngIf="viewMode === 'CLUBS'"
          icon="pi pi-angle-double-up"
          label="Contraer"
          severity="secondary"
          [outlined]="true"
          size="small"
          (onClick)="collapseAll()"
        ></p-button>
        <p-button
          icon="pi pi-file-excel"
          label="Exportar vista avanzada"
          (onClick)="exportAdvancedReport()"
          pTooltip="Exporta clubes, detalle de inscripciones y resumen por estado"
          tooltipPosition="left"
        ></p-button>
      </div>
    </div>
  </div>

  <!-- ===================== ACCIONES MASIVAS ===================== -->
  <div
    class="advanced-registrations__bulk-bar"
    *ngIf="isSuperAdmin && selectedCount > 0"
  >
    <div class="bulk-bar__info">
      <i class="pi pi-check-square"></i>
      <span
        ><strong>{{ selectedCount }}</strong> inscripción(es)
        seleccionada(s)</span
      >
    </div>
    <div class="bulk-bar__actions">
      <p-button
        icon="pi pi-pencil"
        label="Cambiar estado"
        size="small"
        (onClick)="openStatusDialogForSelection()"
      ></p-button>
      <p-button
        icon="pi pi-trash"
        label="Eliminar"
        severity="danger"
        size="small"
        (onClick)="deleteSelection()"
      ></p-button>
      <p-button
        icon="pi pi-times"
        label="Limpiar selección"
        severity="secondary"
        [text]="true"
        size="small"
        (onClick)="clearSelection()"
      ></p-button>
    </div>
  </div>

  <!-- ===================== VISTA POR CLUB ===================== -->
  <p-table
    *ngIf="viewMode === 'CLUBS'"
    [value]="filteredClubSummaries"
    dataKey="clubId"
    [expandedRowKeys]="expandedRows"
    [rows]="10"
    [paginator]="true"
    [rowHover]="true"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="{first} - {last} de {totalRecords} clubes"
    styleClass="p-datatable-sm clubs-table"
  >
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 3rem"></th>
        <th style="width: 3rem" *ngIf="isSuperAdmin"></th>
        <th pSortableColumn="clubName" class="table__header">
          Club / Escuela <p-sortIcon field="clubName" />
        </th>
        <th pSortableColumn="clubRegistrationStatusLabel" class="table__header">
          Inscripción Club <p-sortIcon field="clubRegistrationStatusLabel" />
        </th>
        <th pSortableColumn="total" class="table__header text-center">
          Deportistas <p-sortIcon field="total" />
        </th>
        <th pSortableColumn="registered" class="table__header text-center">
          Inscritos <p-sortIcon field="registered" />
        </th>
        <th pSortableColumn="preRegistered" class="table__header text-center">
          Pre-Inscritos <p-sortIcon field="preRegistered" />
        </th>
        <th pSortableColumn="notRegistered" class="table__header text-center">
          No Inscritos <p-sortIcon field="notRegistered" />
        </th>
        <th pSortableColumn="completionRate" class="table__header">
          Efectividad <p-sortIcon field="completionRate" />
        </th>
        <th pSortableColumn="confirmedAmount" class="table__header text-right">
          Valor Confirmado <p-sortIcon field="confirmedAmount" />
        </th>
        <th pSortableColumn="pendingAmount" class="table__header text-right">
          Valor Pendiente <p-sortIcon field="pendingAmount" />
        </th>
        <th class="table__header text-center" *ngIf="isSuperAdmin">Acciones</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-club let-expanded="expanded">
      <tr class="table__row">
        <td>
          <button
            type="button"
            pButton
            pRipple
            [pRowToggler]="club"
            class="p-button-text p-button-rounded p-button-plain"
            [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
          ></button>
        </td>
        <td *ngIf="isSuperAdmin">
          <p-checkbox
            [ngModel]="isClubFullySelected(club)"
            (onChange)="toggleClubSelection(club, $event.checked)"
            [binary]="true"
            [disabled]="club.rows.length === 0"
            pTooltip="Seleccionar todas las inscripciones del club"
            tooltipPosition="right"
          ></p-checkbox>
        </td>
        <td>
          <div class="club-cell">
            <span class="club-cell__name">{{ club.clubName }}</span>
            <small class="club-cell__contact" *ngIf="club.email || club.telephone">
              {{ club.email }}
              <span *ngIf="club.email && club.telephone"> · </span>
              {{ club.telephone }}
            </small>
            <div class="club-cell__badges">
              <p-tag
                *ngIf="club.isExternal"
                value="Externo"
                severity="info"
              ></p-tag>
              <p-tag
                *ngIf="club.deleted > 0"
                [value]="club.deleted + ' eliminada(s)'"
                severity="danger"
              ></p-tag>
            </div>
          </div>
        </td>
        <td>
          <p-tag
            [value]="club.clubRegistrationStatusLabel"
            [severity]="club.clubRegistrationStatusSeverity"
          ></p-tag>
        </td>
        <td class="text-center">
          <span class="count-pill count-pill--total">{{ club.total }}</span>
        </td>
        <td class="text-center">
          <span class="count-pill count-pill--success">{{
            club.registered
          }}</span>
        </td>
        <td class="text-center">
          <span class="count-pill count-pill--warning">{{
            club.preRegistered
          }}</span>
        </td>
        <td class="text-center">
          <span class="count-pill count-pill--danger">{{
            club.notRegistered
          }}</span>
        </td>
        <td>
          <div class="completion">
            <p-progressBar
              [value]="club.completionRate"
              [showValue]="false"
              styleClass="completion__bar"
            ></p-progressBar>
            <span class="completion__value">{{ club.completionRate }}%</span>
          </div>
        </td>
        <td class="text-right">${{ club.confirmedAmount | number }}</td>
        <td class="text-right">${{ club.pendingAmount | number }}</td>
        <td class="text-center" *ngIf="isSuperAdmin">
          <div class="row-actions">
            <p-button
              icon="pi pi-pencil"
              severity="secondary"
              [text]="true"
              [rounded]="true"
              size="small"
              [disabled]="!club.clubRegistration"
              (onClick)="openStatusDialogForClub(club)"
              pTooltip="Editar el estado de la inscripción del club"
              tooltipPosition="left"
            ></p-button>
            <p-button
              icon="pi pi-trash"
              severity="danger"
              [text]="true"
              [rounded]="true"
              size="small"
              [disabled]="!club.clubRegistration"
              (onClick)="deleteClubRegistration(club)"
              pTooltip="Eliminar la inscripción del club"
              tooltipPosition="left"
            ></p-button>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="rowexpansion" let-club>
      <tr class="expansion-row">
        <td [attr.colspan]="clubColumnsCount">
          <div class="expansion-content">
            <h4 class="expansion-content__title">
              <i class="pi pi-id-card"></i>
              Inscripciones de {{ club.clubName }}
            </h4>

            <p-table
              [value]="club.rows"
              [rows]="10"
              [paginator]="club.rows.length > 10"
              [rowHover]="true"
              styleClass="p-datatable-sm members-table"
            >
              <ng-template pTemplate="header">
                <tr>
                  <th style="width: 3rem" *ngIf="isSuperAdmin">
                    <p-checkbox
                      [ngModel]="isClubFullySelected(club)"
                      (onChange)="toggleClubSelection(club, $event.checked)"
                      [binary]="true"
                      [disabled]="club.rows.length === 0"
                    ></p-checkbox>
                  </th>
                  <th class="table__header">Identificación</th>
                  <th class="table__header">Nombres</th>
                  <th class="table__header">Apellidos</th>
                  <th class="table__header">F. Nacimiento</th>
                  <th class="table__header">Edad (Corte)</th>
                  <th class="table__header">Nivel</th>
                  <th class="table__header">Categoría</th>
                  <th class="table__header">Rama</th>
                  <th class="table__header">Estado</th>
                  <th class="table__header">Tipo Inscripción</th>
                  <th class="table__header">Estado Pago</th>
                  <th class="table__header">Medio de Pago</th>
                  <th class="table__header" *ngIf="competition.hasCrosselling">
                    Venta Cruzada
                  </th>
                  <th class="table__header">Fecha Registro</th>
                  <th class="table__header text-right">Valor</th>
                  <th class="table__header text-center" *ngIf="isSuperAdmin">
                    Acciones
                  </th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-row>
                <tr
                  class="table__row"
                  [class.table__row--incomplete]="!row.hasMemberData"
                  [class.table__row--deleted]="!row.isActive"
                >
                  <td *ngIf="isSuperAdmin">
                    <p-checkbox
                      [ngModel]="isSelected(row)"
                      (onChange)="toggleRowSelection(row, $event.checked)"
                      [binary]="true"
                    ></p-checkbox>
                  </td>
                  <td>
                    {{ row.identification }}
                    <p-tag
                      *ngIf="!row.hasMemberData"
                      value="Deportista eliminado"
                      severity="danger"
                    ></p-tag>
                  </td>
                  <td>{{ row.name }}</td>
                  <td>{{ row.lastName }}</td>
                  <td>{{ row.birthDay }}</td>
                  <td>{{ row.age !== null ? row.age : 'N/D' }}</td>
                  <td>{{ row.level }}</td>
                  <td>{{ row.category }}</td>
                  <td>{{ row.genderLabel }}</td>
                  <td>
                    <p-tag
                      [value]="row.statusLabel"
                      [severity]="row.statusSeverity"
                    ></p-tag>
                    <p-tag
                      *ngIf="!row.isActive"
                      value="Eliminada"
                      severity="danger"
                      styleClass="ml-1"
                    ></p-tag>
                  </td>
                  <td>{{ row.temporalTypeLabel }}</td>
                  <td>
                    <p-tag
                      [value]="row.paymentStatusLabel"
                      [severity]="row.paymentStatusSeverity"
                      [pTooltip]="
                        row.paymentId ? 'Referencia: ' + row.paymentId : ''
                      "
                      tooltipPosition="top"
                    ></p-tag>
                  </td>
                  <td>{{ row.paymentTypeLabel }}</td>
                  <td *ngIf="competition.hasCrosselling">
                    {{ row.crossSellingDescription || 'N/A' }}
                  </td>
                  <td>{{ row.registrationDate }}</td>
                  <td class="text-right">${{ row.totalAmount | number }}</td>
                  <td class="text-center" *ngIf="isSuperAdmin">
                    <div class="row-actions">
                      <p-button
                        *ngIf="row.isActive"
                        icon="pi pi-pencil"
                        severity="secondary"
                        [text]="true"
                        [rounded]="true"
                        size="small"
                        (onClick)="openStatusDialogForRow(row)"
                        pTooltip="Cambiar estado de la inscripción"
                        tooltipPosition="left"
                      ></p-button>
                      <p-button
                        *ngIf="row.isActive"
                        icon="pi pi-trash"
                        severity="danger"
                        [text]="true"
                        [rounded]="true"
                        size="small"
                        (onClick)="deleteRow(row)"
                        pTooltip="Eliminar inscripción"
                        tooltipPosition="left"
                      ></p-button>
                      <p-button
                        *ngIf="!row.isActive"
                        icon="pi pi-undo"
                        severity="success"
                        [text]="true"
                        [rounded]="true"
                        size="small"
                        (onClick)="restoreRow(row)"
                        pTooltip="Restaurar inscripción"
                        tooltipPosition="left"
                      ></p-button>
                    </div>
                  </td>
                </tr>
              </ng-template>

              <ng-template pTemplate="emptymessage">
                <tr>
                  <td [attr.colspan]="memberColumnsCount">
                    Este club no tiene inscripciones de deportistas que coincidan
                    con los filtros aplicados.
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="clubColumnsCount">
          No se encontraron clubes o escuelas con los filtros aplicados.
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="summary">
      <div class="flex align-items-center justify-content-between">
        <span>
          {{ filteredClubSummaries.length }} clubes / escuelas ·
          {{ totals.registrations }} inscripciones
        </span>
      </div>
    </ng-template>
  </p-table>

  <!-- ===================== VISTA DETALLADA ===================== -->
  <p-table
    *ngIf="viewMode === 'DETAIL'"
    [value]="filteredRows"
    [rows]="15"
    [paginator]="true"
    [rowHover]="true"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="{first} - {last} de {totalRecords} inscripciones"
    styleClass="p-datatable-sm detail-table"
  >
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 3rem" *ngIf="isSuperAdmin">
          <p-checkbox
            [ngModel]="areAllFilteredRowsSelected"
            (onChange)="toggleAllFilteredRows($event.checked)"
            [binary]="true"
            [disabled]="filteredRows.length === 0"
            pTooltip="Seleccionar todas las inscripciones filtradas"
            tooltipPosition="right"
          ></p-checkbox>
        </th>
        <th pSortableColumn="clubName" class="table__header">
          Club / Escuela <p-sortIcon field="clubName" />
        </th>
        <th pSortableColumn="identification" class="table__header">
          Identificación <p-sortIcon field="identification" />
        </th>
        <th pSortableColumn="name" class="table__header">
          Nombres <p-sortIcon field="name" />
        </th>
        <th pSortableColumn="lastName" class="table__header">
          Apellidos <p-sortIcon field="lastName" />
        </th>
        <th pSortableColumn="birthDay" class="table__header">
          F. Nacimiento <p-sortIcon field="birthDay" />
        </th>
        <th pSortableColumn="age" class="table__header">
          Edad (Corte) <p-sortIcon field="age" />
        </th>
        <th pSortableColumn="level" class="table__header">
          Nivel <p-sortIcon field="level" />
        </th>
        <th pSortableColumn="category" class="table__header">
          Categoría <p-sortIcon field="category" />
        </th>
        <th pSortableColumn="genderLabel" class="table__header">
          Rama <p-sortIcon field="genderLabel" />
        </th>
        <th pSortableColumn="statusLabel" class="table__header">
          Estado <p-sortIcon field="statusLabel" />
        </th>
        <th pSortableColumn="temporalTypeLabel" class="table__header">
          Tipo Inscripción <p-sortIcon field="temporalTypeLabel" />
        </th>
        <th pSortableColumn="paymentStatusLabel" class="table__header">
          Estado Pago <p-sortIcon field="paymentStatusLabel" />
        </th>
        <th pSortableColumn="paymentTypeLabel" class="table__header">
          Medio de Pago <p-sortIcon field="paymentTypeLabel" />
        </th>
        <th class="table__header" *ngIf="competition.hasCrosselling">
          Venta Cruzada
        </th>
        <th pSortableColumn="registrationDate" class="table__header">
          Fecha Registro <p-sortIcon field="registrationDate" />
        </th>
        <th pSortableColumn="totalAmount" class="table__header text-right">
          Valor <p-sortIcon field="totalAmount" />
        </th>
        <th class="table__header text-center" *ngIf="isSuperAdmin">Acciones</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row>
      <tr
        class="table__row"
        [class.table__row--incomplete]="!row.hasMemberData"
        [class.table__row--deleted]="!row.isActive"
      >
        <td *ngIf="isSuperAdmin">
          <p-checkbox
            [ngModel]="isSelected(row)"
            (onChange)="toggleRowSelection(row, $event.checked)"
            [binary]="true"
          ></p-checkbox>
        </td>
        <td>{{ row.clubName }}</td>
        <td>
          {{ row.identification }}
          <p-tag
            *ngIf="!row.hasMemberData"
            value="Deportista eliminado"
            severity="danger"
          ></p-tag>
        </td>
        <td>{{ row.name }}</td>
        <td>{{ row.lastName }}</td>
        <td>{{ row.birthDay }}</td>
        <td>{{ row.age !== null ? row.age : 'N/D' }}</td>
        <td>{{ row.level }}</td>
        <td>{{ row.category }}</td>
        <td>{{ row.genderLabel }}</td>
        <td>
          <p-tag
            [value]="row.statusLabel"
            [severity]="row.statusSeverity"
          ></p-tag>
          <p-tag
            *ngIf="!row.isActive"
            value="Eliminada"
            severity="danger"
            styleClass="ml-1"
          ></p-tag>
        </td>
        <td>{{ row.temporalTypeLabel }}</td>
        <td>
          <p-tag
            [value]="row.paymentStatusLabel"
            [severity]="row.paymentStatusSeverity"
            [pTooltip]="row.paymentId ? 'Referencia: ' + row.paymentId : ''"
            tooltipPosition="top"
          ></p-tag>
        </td>
        <td>{{ row.paymentTypeLabel }}</td>
        <td *ngIf="competition.hasCrosselling">
          {{ row.crossSellingDescription || 'N/A' }}
        </td>
        <td>{{ row.registrationDate }}</td>
        <td class="text-right">${{ row.totalAmount | number }}</td>
        <td class="text-center" *ngIf="isSuperAdmin">
          <div class="row-actions">
            <p-button
              *ngIf="row.isActive"
              icon="pi pi-pencil"
              severity="secondary"
              [text]="true"
              [rounded]="true"
              size="small"
              (onClick)="openStatusDialogForRow(row)"
              pTooltip="Cambiar estado de la inscripción"
              tooltipPosition="left"
            ></p-button>
            <p-button
              *ngIf="row.isActive"
              icon="pi pi-trash"
              severity="danger"
              [text]="true"
              [rounded]="true"
              size="small"
              (onClick)="deleteRow(row)"
              pTooltip="Eliminar inscripción"
              tooltipPosition="left"
            ></p-button>
            <p-button
              *ngIf="!row.isActive"
              icon="pi pi-undo"
              severity="success"
              [text]="true"
              [rounded]="true"
              size="small"
              (onClick)="restoreRow(row)"
              pTooltip="Restaurar inscripción"
              tooltipPosition="left"
            ></p-button>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="detailColumnsCount">
          No se encontraron inscripciones con los filtros aplicados.
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="summary">
      <div class="flex align-items-center justify-content-between">
        {{ filteredRows.length }} inscripciones en total.
      </div>
    </ng-template>
  </p-table>
</div>

<!-- ===================== DIÁLOGO DE EDICIÓN DE ESTADO ===================== -->
<p-dialog
  [header]="
    registrationsToEdit.length > 1
      ? 'Editar ' + registrationsToEdit.length + ' inscripciones'
      : 'Editar inscripción'
  "
  [(visible)]="showStatusDialog"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  appendTo="body"
  [style]="{ width: '520px' }"
  (onHide)="closeStatusDialog()"
>
  <div class="status-dialog">
    <div class="status-dialog__targets">
      <span class="status-dialog__label">Inscripciones afectadas</span>
      <ul>
        <li *ngFor="let label of registrationsToEditLabels.slice(0, 8)">
          {{ label }}
        </li>
        <li
          *ngIf="registrationsToEditLabels.length > 8"
          class="status-dialog__more"
        >
          y {{ registrationsToEditLabels.length - 8 }} más...
        </li>
      </ul>
    </div>

    <div class="status-dialog__field">
      <label for="newStatus">Nuevo estado</label>
      <p-dropdown
        inputId="newStatus"
        [options]="statusOptions"
        [(ngModel)]="newStatus"
        optionLabel="label"
        optionValue="value"
        placeholder="Selecciona el estado"
        appendTo="body"
        styleClass="w-full"
      ></p-dropdown>
    </div>

    <div class="status-dialog__field">
      <label for="editComment">Observación (opcional)</label>
      <textarea
        pInputTextarea
        id="editComment"
        [(ngModel)]="editComment"
        rows="3"
        placeholder="Motivo del cambio, queda registrado en la inscripción"
      ></textarea>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <p-button
      label="Cancelar"
      severity="secondary"
      [outlined]="true"
      (onClick)="closeStatusDialog()"
    ></p-button>
    <p-button
      label="Guardar cambios"
      icon="pi pi-check"
      [disabled]="!newStatus"
      (onClick)="confirmStatusChange()"
    ></p-button>
  </ng-template>
</p-dialog>
